import styled, { css } from "styled-components";
import { pxToRem } from "../../styles/utils";

export const StyledBadge = styled.div.withConfig({
  shouldForwardProp: (prop) => !["variant", "asButton"].includes(prop),
})<{ variant: "green" | "red"; asButton: boolean }>`
  display: inline-block;
  min-width: ${pxToRem(52)};
  box-sizing: border-box;
  border-radius: ${pxToRem(6)};
  padding: ${pxToRem(6)} ${pxToRem(12)};
  font-size: ${pxToRem(14)};
  font-weight: 600;
  text-align: center;
  margin: ${pxToRem(5)};
  cursor: ${({ asButton }) => (asButton ? "pointer" : "default")};
 white-space: nowrap;



  ${({ variant }) =>
    variant === "green"
      ? css`
          border: ${pxToRem(1)} solid rgb(86, 189, 116);
          box-shadow: 0px ${pxToRem(4)} ${pxToRem(4)} 0px rgba(86, 189, 116, 0.6);
          background: rgba(86, 189, 116, 0.1);
          color: rgb(86, 189, 116);
        `
      : css`
          border: ${pxToRem(1)} solid rgb(242, 40, 98);
          box-shadow: 0px ${pxToRem(4)} ${pxToRem(4)} 0px rgba(242, 40, 98, 0.6);
          background: rgba(242, 40, 98, 0.1);
          color: rgb(242, 40, 98);
        `}

  &:hover {
    ${({ asButton, variant }) =>
      asButton &&
      css`
        box-shadow: 0px ${pxToRem(6)} ${pxToRem(6)} 0px
          ${variant === "green"
            ? "rgba(86, 189, 116, 0.8)"
            : "rgba(242, 40, 98, 0.8)"};
      `}
  }
`;
